import styled from "styled-components/macro";
import { Paper as MuiPaper, Grid } from "@mui/material";

const NonShadowPaper = styled(MuiPaper)`
  border-radius: 10px;
  margin: 10px 0;
  padding: 15px;
`;
export default function Paper({
  gridSpacing,
  variant,
  noGrid,
  gridProps,
  ...props
}) {
  return (
    <NonShadowPaper variant={variant} {...props}>
      {Boolean(noGrid) ? (
        props.children
      ) : (
        <Grid
          container
          alignItems="flex-start"
          {...gridProps}
          spacing={gridSpacing ?? 4}
        >
          {props.children}
        </Grid>
      )}
    </NonShadowPaper>
  );
}
